<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import commitStore from './store.js'

export default {
  name: 'commit',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('commit', commitStore)
  },
}
</script>
